module.exports = __webpack_public_path__ + "static/img/hxyh.2cbeb18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hxyh.png
// module id = 30yK
// module chunks = 44